// Track scrolling past announcement bar
const announcementBar = document.querySelector('.announcement-bar-background');

if (announcementBar) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        document.body.classList.add('has-scrolled');
      } else {
        document.body.classList.remove('has-scrolled'); 
      }
    });
  }, {
    threshold: 0,
    rootMargin: '0px'
  });

  observer.observe(announcementBar);
}
